enum IntakeSteps {
  CASE_REFERRAL,
  COURT_INFORMATION,
  INDIVIDUAL_DETAILS,
  PROGRAM_DETAILS,
  REVIEW_CASE_DETAILS,
  FORM_COMPLETE,
  ADD_CHILD,
}

export default IntakeSteps;
